var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-autocomplete', _vm._b({
    attrs: {
      "items": _vm.users,
      "item-text": _vm.itemText,
      "item-value": "_id"
    },
    on: {
      "click": _vm.alert
    },
    model: {
      value: _vm.$data._user,
      callback: function callback($$v) {
        _vm.$set(_vm.$data, "_user", $$v);
      },
      expression: "$data._user"
    }
  }, 'v-autocomplete', _vm.$attrs, false));
}
var staticRenderFns = []

export { render, staticRenderFns }